import HotelImageSrc from '../../../assets/images/promos/hotel-image-2x.jpg'
import HotelImageSrcWebp from '../../../assets/images/promos/hotel-image-2x.webp'
import HotelImageTabletSrc from '../../../assets/images/promos/hotel-image-tablet-2x.jpg'
import HotelImageTabletSrcWebp from '../../../assets/images/promos/hotel-image-tablet-2x.webp'

const CONTENT = {
  headline1: '10% off',
  headline2: 'coupon',
  subHeadline:
    'Book anything today and get 10% off your next Express Deal® Hotel',
  moreInfoText: 'Coupon emailed after trip.',
  boxLink: null,
  desktopImageJPGUrl: HotelImageSrc,
  desktopImageWEBPUrl: HotelImageSrcWebp,
  tabletImageJPGUrl: HotelImageTabletSrc,
  tabletImageWEBPUrl: HotelImageTabletSrcWebp,
  analytics: {
    category: 'promotion',
    action: 'holiday-2020',
    data: 'HOMEPAGE|promo-banner|SOS-week-2'
  }
}

export default CONTENT
